import { useQueryStringParameters } from '@common/hooks/useQueryStringParameters/useQueryStringParameters';
import { GetEstimateDto } from '@common/models/save-estimate-dto';
import { EstimateQueryParams, useFetchEstimateQuery } from '@ee-api/estimate-api/estimateService';
import { useAppSelector } from '@redux/hooks';
import { selectIgnoreFetchedEstimate, selectLoadEstimateKeys } from '@redux/slices/estimateSlice';
import { TypedUseQueryHookResult } from '@reduxjs/toolkit/dist/query/react';
import { skipToken } from '@reduxjs/toolkit/query';

import { AxiosBaseQueryFunction } from '../../api/axiosBaseQuery';

type useFetchedEstimateReturn = TypedUseQueryHookResult<GetEstimateDto, EstimateQueryParams, AxiosBaseQueryFunction> & {
    fetchedEstimate: GetEstimateDto | undefined;
    isFetchingEstimate: boolean;
};

const useFetchedEstimate = (): useFetchedEstimateReturn => {
    const { loadEstimateCode } = useQueryStringParameters();
    const loadEstimateKeys = useAppSelector(selectLoadEstimateKeys);
    const ignoreFetched = useAppSelector(selectIgnoreFetchedEstimate);

    const { fetchedEstimate, ...rest } = useFetchEstimateQuery(
        loadEstimateCode || (loadEstimateKeys && loadEstimateKeys.estimateNumber && loadEstimateKeys.email)
            ? {
                  params: {
                      code: loadEstimateCode,
                      estimateNumber: loadEstimateKeys?.estimateNumber,
                      customerEmail: loadEstimateKeys?.email,
                  },
              }
            : skipToken,
        {
            refetchOnFocus: false,
            refetchOnReconnect: false,
            selectFromResult: (result) => {
                return {
                    fetchedEstimate: result.isError || ignoreFetched ? undefined : result.data,
                    ...result,
                };
            },
        }
    );

    return {
        fetchedEstimate,
        isFetchingEstimate: rest.isFetching,
        ...rest,
    };
};

export default useFetchedEstimate;
